import { Routes } from './routes';
import { mesPreset, darkPreset } from '@assets/css/consta-theme-modify/mes-preset';
import { Theme } from '@consta/uikit/Theme';
import '@assets/css/index.scss';
import '@assets/css/modal.scss';
import '@assets/css/table.scss';
import '@assets/css/tree.scss';
import '@assets/css/animations.scss';
import '@assets/css/left-menu.scss';
import '@assets/css/login-page.scss';
import '@assets/css/dhx-table.scss';
import '@assets/css/inputs.scss';
import '@assets/css/collapse.scss';
import '@assets/css/gantt.css';
import '@assets/css/ql-rich-text.css';
import '@assets/css/dhx.components.css';
import '@assets/css/snack-bar.css';
// import { BreadcrumbsProvider } from './contexts/breadcrumbs';
import { Login } from '@pages/login';
import { useSelector } from 'react-redux';
import { RootState } from '@store/index';
import moment from 'moment';
import 'moment/dist/locale/ru';
// import FitScreen from '@fit-screen/react';
// import { Singleton } from './singletons/socket-singleton';
// import { useEffect } from 'react';

moment.locale('ru');

const App = () => {
    const { accessToken } = useSelector((state: RootState) => state.userStore);

    // useEffect(() => {
    //     Singleton.getInstance();
    // }, [])

    if (!accessToken) {
        return (
            <Theme preset={darkPreset}>
                <Login />
            </Theme>
        );
    }

    return (
        <Theme preset={mesPreset}>
            <Routes />
        </Theme>
    );
};

export default App;
